import { CanDeactivateFn } from '@angular/router';
import { EditingFacade } from '../state/dialogs/editing/editing.facade';
import { inject } from '@angular/core';
import { filter, tap } from 'rxjs';

export const editingGuard: CanDeactivateFn<boolean> = () => {
  const editingFacade = inject(EditingFacade);

  if (editingFacade.isEditing) {
    editingFacade.setEditingModalOpen(true);

    return editingFacade.closeResult$.pipe(
      filter((closeResult) => typeof closeResult === 'boolean'),
      tap(() => editingFacade.setEditingModalOpen(false)),
      tap(() => editingFacade.setCloseResult(null)), // TODO: Necessary to reset the close result state
      tap((closeResult) => {
        if (closeResult) {
          editingFacade.setEditing(false);
        }
      }),
    )
  }

  return true;
};
